var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-album", { attrs: { profil: _vm.profil } }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "albumMainBody" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sideMenu__close",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "profil" })
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "albumList__separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "albumListing__wrap" }, [
            _c("div", { staticClass: "albumList__half --first" }, [
              _c(
                "div",
                {
                  staticClass:
                    "albumList__heading mb-3 d-flex align-items-center justify-content-between"
                },
                [
                  _c("h2", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.recept_nadpis))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "recept__images" }, [
                _c("div", { staticClass: "recept__mainImage mb-4" }, [
                  _vm.recept_img_a == ""
                    ? _c("img", {
                        staticClass: "img-fluid --rounded",
                        staticStyle: {
                          filter:
                            "brightness(0) invert(1) drop-shadow(0 0 2px #E0DBDA)"
                        },
                        attrs: {
                          src: "assets/img/album/recepty/ranajky-sendvic.jpg",
                          alt: ""
                        }
                      })
                    : _c("img", {
                        staticClass: "img-fluid --rounded",
                        attrs: {
                          src: "assets/img/album/recepty/" + _vm.recept_img_a,
                          alt: ""
                        }
                      })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "recept__mainWrap" }, [
                  _c("div", { staticClass: "recept__ingredients" }, [
                    _c("span", { staticClass: "recept__label" }, [
                      _vm._v("Potrebujeme")
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { domProps: { innerHTML: _vm._s(_vm.recept_priprava) } },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.recept_priprava) +
                            "\n                                "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "albumList__half --second" }, [
              _c("div", { staticClass: "recept__mainWrap" }, [
                _c("div", { staticClass: "recept__workaround" }, [
                  _c("span", { staticClass: "recept__label" }, [
                    _vm._v("Postup")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.recept_postup))])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "albumListing__nav --prev" },
            [
              _c("router-link", { attrs: { to: { name: "album-recepty" } } }, [
                _c("span", { staticClass: "icon --prev" }),
                _vm._v("Späť na zoznam receptov\n                ")
              ])
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "albumPages" }, [
      _c("div", { staticClass: "albumPage --first" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --second" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --third" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --fourth" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }